import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
export const Alert = ({ id, className, onClose, children, icon: Icon, }) => {
    return (_jsxs("div", { id: id, role: "alert", className: classNames("cvr-alert", className), children: [children, onClose && (_jsx("button", { "aria-label": "Close alert", className: "cvr-alert-btn", onClick: onClose, type: "button", children: Icon ? _jsx(Icon, {}) : "Lukk" }))] }));
};
export default Alert;
